import React from 'react';
import { useNavigate } from 'react-router-dom';

function Cancel() {
  const navigate = useNavigate();

  return (
    <div className="cancel-page">
      <h2>Payment Cancelled</h2>
      <p>Your payment was cancelled. You can try again when you're ready.</p>
      <button onClick={() => navigate('/')} className="retry-button">
        Return to Game
      </button>
    </div>
  );
}

export default Cancel; 